// extracted by mini-css-extract-plugin
export default {"WarningModalContent":"sgp-client-HOC-withUserSessionMonitor--styles--WarningModalContent","btnWrapper":"sgp-client-HOC-withUserSessionMonitor--styles--btnWrapper"};